import script from "./PresetAmountGrid.vue?vue&type=script&setup=true&lang=ts"
export * from "./PresetAmountGrid.vue?vue&type=script&setup=true&lang=ts"

import "./PresetAmountGrid.vue?vue&type=style&index=0&id=4e45cd44&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e45cd44"]])

export default __exports__